var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgMicrophoneIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M12 1a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5ZM2.192 13.961l1.962-.392a8.003 8.003 0 0 0 15.692 0l1.962.392C20.896 18.545 16.852 22 12 22c-4.851 0-8.896-3.455-9.808-8.039Z", fill: "#CCAC85" }));
export { SvgMicrophoneIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDFhNSA1IDAgMCAxIDUgNXY2YTUgNSAwIDAgMS0xMCAwVjZhNSA1IDAgMCAxIDUtNVpNMi4xOTIgMTMuOTYxbDEuOTYyLS4zOTJhOC4wMDMgOC4wMDMgMCAwIDAgMTUuNjkyIDBsMS45NjIuMzkyQzIwLjg5NiAxOC41NDUgMTYuODUyIDIyIDEyIDIyYy00Ljg1MSAwLTguODk2LTMuNDU1LTkuODA4LTguMDM5WiIgZmlsbD0iI0NDQUM4NSIvPjwvc3ZnPg==";
